import React from 'react';
import PropTypes from 'prop-types';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const Link = (props) => {
    const { offerName, affiliateName } = useParams();

    const getSearch = () => new URLSearchParams(props.history.location.search).toString();

    if (!props.user.affiliate) {
        if (affiliateName) {
            return <>{props.value}</>;
        }
        else if (offerName) {
            return (
                <RouterLink to={`/reports/summary/${offerName}/${props.value}/?${getSearch()}`}>
                    {props.value}
                </RouterLink>
            );
        }
        else {
            return <RouterLink to={`/reports/summary/${props.value}/?${getSearch()}`}>{props.value}</RouterLink>;
        }
    }
    else {
        return <>{props.value}</>;
    }
};

Link.propTypes = {
    value: PropTypes.node.isRequired,
};

let Component = Link;
Component = withRouter(Component);

export default connect(
    (state) => ({
        user: state.auth.user,
    })
)(Component);
